/* eslint-disable no-extra-boolean-cast */
import axios, { AxiosRequestConfig } from 'axios';
import getRoutePublic from 'layouts/PublicLayout/getRoutePublic';
import { findIndex, get } from 'lodash';
import merge from 'lodash/merge';
import QueryString from 'qs';
import { onLogout } from 'utils/common';
import { REACT_APP_SSO_API, REACT_APP_CUSTOMER_API, REACT_APP_UPLOAD_FILE, REACT_APP_PRICE_API } from 'utils/env';
import { getStorageData, STORAGE_KEY } from 'utils/storage';

axios.defaults.timeout = 15000;
axios.defaults.timeoutErrorMessage = 'Mất kết nối. Vui lòng thử lại sau';
axios.defaults.paramsSerializer = (params): string => QueryString.stringify(params, { indices: false });

const configureSSO = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const token = getStorageData<string>(STORAGE_KEY.ACCESS_TOKEN);
  const targetConfig: AxiosRequestConfig = {
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${token}`,
    }
  };
  return merge(targetConfig, config);
};

/** Request API */
export const apiAppSSO = axios.create({
  baseURL: REACT_APP_SSO_API,
});

apiAppSSO.interceptors.request.use(
  (config) => Promise.resolve(configureSSO(config)),
  (error) => Promise.reject(error)
);

apiAppSSO.interceptors.response.use(
  response => Promise.resolve(response),
  error => Promise.reject(configErrorGN(error)),
);

const configure = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const token = getStorageData<string>(STORAGE_KEY.ACCESS_TOKEN);
  const targetConfig: AxiosRequestConfig = {
    headers: {
      Authorization: `${token}`,
    }
  };
  return merge(config, targetConfig);
};

/** Request API */
export const apiApp = axios.create({
  baseURL: REACT_APP_CUSTOMER_API,
});

apiApp.interceptors.request.use(
  (config) => Promise.resolve(configure(config)),
  (error) => Promise.reject(error)
);

apiApp.interceptors.response.use(
  response => Promise.resolve(response),
  error => Promise.reject(configErrorGN(error)),
);

let flagRedirect = true;
//eslint-disable-next-line @typescript-eslint/no-explicit-any
const configErrorGN = (error: any): any => {
  // const data = get(error, 'response.data');
  const status = get(error, 'response.status');

  const isPublic = findIndex(getRoutePublic(), item => item.path === window.location.pathname) !== -1
  if (!isPublic) {
    if (flagRedirect && status === 401) {
      flagRedirect = false;
      onLogout();
    }
  }

  return error;
};

////
// upload
export const apiAppUpload = axios.create({
  baseURL: REACT_APP_UPLOAD_FILE,
});

apiAppUpload.interceptors.request.use(
  (config) => Promise.resolve(configureUpload(config)),
  (error) => Promise.reject(error)
);

const configureUpload = (config: AxiosRequestConfig): AxiosRequestConfig => {
  const token = getStorageData<string>(STORAGE_KEY.ACCESS_TOKEN);
  const targetConfig: AxiosRequestConfig = {
    headers: {
      Accept: '*/*',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data'
    }
  };
  return merge(targetConfig, config);
};

/// price api
export const apiPrice = axios.create({
  baseURL: REACT_APP_PRICE_API,
});

apiPrice.interceptors.request.use(
  (config) => Promise.resolve(configureSSO(config)),
  (error) => Promise.reject(error)
);

apiPrice.interceptors.response.use(
  response => Promise.resolve(response),
  error => Promise.reject(configErrorGN(error)),
);

// NOTI
export const apiAppNOTI = axios.create({
  baseURL: REACT_APP_CUSTOMER_API,
});

apiAppNOTI.interceptors.request.use(
  (config) => Promise.resolve(configure(config)),
  (error) => Promise.reject(error)
);

apiAppNOTI.interceptors.response.use(
  response => Promise.resolve(response)
);
// Public CMS — không cần auth token (bài viết public)
export const apiAppCMS = axios.create({
  baseURL: REACT_APP_CUSTOMER_API,
});

// Public CMS API — dùng cho tracking public (không cần auth)
export const apiPublicCMS = axios.create({
  baseURL: REACT_APP_CUSTOMER_API,
  timeout: 15000,
});

apiPublicCMS.interceptors.response.use(
  response => Promise.resolve(response),
  error => Promise.reject(error),
);
